import { render } from "./VtoHeaderDescription.vue?vue&type=template&id=1452c949"
import script from "./VtoHeaderDescription.vue?vue&type=script&lang=js"
export * from "./VtoHeaderDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__